<!-- DISPLAY ONLY -->
<ng-container *ngIf="addFormType === 'displayOnlyType'">
  <div *ngFor="let location of hierarchyOfLocationsData"
    class="location-item fs-14">
    <div>
      <ng-container
        *ngIf="(!location.alternateOrganizationUnitId && !location.locationCode) && (location.childLocations && location.childLocations.length); else leafNodeLocationTemplate">
        <div class="location-header">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="location.expanded = !location.expanded"
            [id]="'button-caret-level-'+location.level+'-'+location.organizationUnitId">
            <i class="fa"
              [ngClass]="location.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-'+location.level+'-'+location.organizationUnitId"></i>
          </button>
          <span [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">{{ location.locationName
            }}</span>
        </div>
        <div *ngIf="location.expanded"
          class="location-children">
          <ng-container
            *ngTemplateOutlet="recursiveListDisplayOnly; context: { $implicit: location.childLocations }"></ng-container>
        </div>
      </ng-container>
      <ng-template #leafNodeLocationTemplate>
        <div>
          <span class="ms-4 ps-3"
            [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">{{ location.locationName
            }}</span>
        </div>
      </ng-template>
    </div>
  </div>

  <ng-template #recursiveListDisplayOnly
    let-childLocations>
    <div *ngFor="let childLocation of childLocations"
      class="location-item fs-14">
      <ng-container *ngIf="childLocation.childLocations?.length; else leafNodeLocationTemplate">
        <div class="location-header">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="childLocation.expanded = !childLocation.expanded"
            [id]="'button-caret-level-' + childLocation.level + '-' + childLocation.organizationUnitId">
            <i class="fa"
              [ngClass]="childLocation.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-' + childLocation.level + '-' + childLocation.organizationUnitId"></i>
          </button>
          <span [id]="'location-name-level-' + childLocation.level + '-' + childLocation.organizationUnitId">
            {{ childLocation.locationName }}
          </span>
        </div>

        <div *ngIf="childLocation.expanded"
          class="location-children">
          <ng-container
            *ngTemplateOutlet="recursiveListDisplayOnly; context: { $implicit: childLocation.childLocations }"></ng-container>
        </div>
      </ng-container>
      <ng-template #leafNodeLocationTemplate>
        <div>
          <span class="ms-4 ps-3"
            [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">{{childLocation.locationName}}</span>
        </div>
      </ng-template>
    </div>
  </ng-template>
</ng-container>

<!-- RADIO BUTTON -->
<ng-container *ngIf="addFormType === 'radioType'">
  <div *ngFor="let location of hierarchyOfLocationsData; let i = index"
    class="location-item fs-14">
    <div>
      <ng-container
        *ngIf="(!location.alternateOrganizationUnitId && !location.locationCode) && (location.childLocations && location.childLocations.length); else leafNodeLocationTemplate">
        <div class="location-header">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="toggleNodeRadio(location, i)"
            [id]="'button-caret-level-'+location.level+'-'+location.organizationUnitId">
            <i class="fa"
              [ngClass]="location.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-'+location.level+'-'+location.organizationUnitId"></i>
          </button>
          <span [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">{{ location.locationName
            }}</span>
        </div>
        <div *ngIf="location.expanded"
          class="location-children">
          <ng-container
            *ngTemplateOutlet="recursiveListRadio; context: { $implicit: location.childLocations, index: i }"></ng-container>
        </div>
      </ng-container>
      <ng-template #leafNodeLocationTemplate>
        <div *ngIf="addFormType === 'radioType' && location.locationName.trim().toUpperCase() !== 'NOT VALIDATED'"
          class="location-radio">
          <input class="mb-1 custom-radio"
            type="radio"
            name="location"
            [value]="location.alternateOrganizationUnitId"
            [(ngModel)]="selectedLocationIdentifier"
            (change)="onRadioButtonSelectionChange(location)"
            [id]="'radio-button-level-'+location.level+'-'+location.organizationUnitId">
          <span class="ms-2"
            [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">{{ location.locationName
            }}</span>
        </div>
      </ng-template>
    </div>
  </div>

  <ng-template #recursiveListRadio
    let-childLocations
    let-index="index">
    <div *ngFor="let childLocation of childLocations"
      class="location-item fs-14">
      <ng-container
        *ngIf="(!childLocation.alternateOrganizationUnitId && !childLocation.locationCode) && (childLocation.childLocations && childLocation.childLocations.length); else leafNodeLocationTemplate">
        <div class="location-header">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="toggleNodeRadio(childLocation, index)"
            [id]="'button-caret-level-' + childLocation.level + '-' + childLocation.organizationUnitId">
            <i class="fa"
              [ngClass]="childLocation.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-' + childLocation.level + '-' + childLocation.organizationUnitId"></i>
          </button>
          <span [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">{{
            childLocation.locationName
            }}</span>
        </div>
        <div *ngIf="childLocation.expanded"
          class="location-children">
          <ng-container
            *ngTemplateOutlet="recursiveListRadio; context: { $implicit: childLocation.childLocations, index: index }"></ng-container>
        </div>
      </ng-container>
      <ng-template #leafNodeLocationTemplate>
        <div *ngIf="addFormType === 'radioType' && childLocation.locationName.trim().toUpperCase() !== 'NOT VALIDATED'"
          class="location-radio">
          <input class="mb-1 custom-radio"
            type="radio"
            name="location"
            [value]="childLocation.alternateOrganizationUnitId"
            [(ngModel)]="selectedLocationIdentifier"
            (change)="onRadioButtonSelectionChange(childLocation)"
            [id]="'radio-button-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
          <span class="ms-2"
            [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">{{childLocation.locationName}}</span>
        </div>
      </ng-template>
    </div>
  </ng-template>
</ng-container>

<!-- CHECKBOX -->
<ng-container *ngIf="addFormType === 'checkboxType'">
  <div *ngFor="let location of hierarchyOfLocationsData"
    class="location-item fs-14 my-2">
    <div>
      <ng-container
        *ngIf="location.childLocations && location.childLocations.length; else leafNodeLocationTemplateCheckbox">
        <div class="d-flex align-items-center location-header my-2">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="location.expanded = !location.expanded"
            [id]="'button-caret-level-'+location.level+'-'+location.organizationUnitId">
            <i class="fa"
              [ngClass]="location.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-'+location.level+'-'+location.organizationUnitId"></i>
          </button>
          <label class="checkbox-inline-medium me-2">
            <input type="checkbox"
              [(ngModel)]="location.checked"
              (change)="onCheckboxSelectionChange(location, location.checked)"
              [id]="'checkbox-level-'+location.level+'-'+location.organizationUnitId">
          </label>
          <span class="text-block-dark"
            [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">{{ location.locationName
            }}</span>
          <a href="javascript:void(0)"
            (click)="establishmentInfo(childLocation)"> <i class="fa fa-info-circle"
              style="color: #2477bf;margin-left: 8px;font-size: 18px !important;"
              *ngIf="location?.hasEstablishment && oshaHol==='osha'"
              [id]="'icon-info-circle-level-'+location.level+'-'+location.organizationUnitId"></i>
          </a>
        </div>
        <div *ngIf="location.expanded"
          class="location-children my-2">
          <ng-container
            *ngTemplateOutlet="recursiveListCheckbox; context: { $implicit: location.childLocations }"></ng-container>
        </div>
      </ng-container>
      <ng-template #leafNodeLocationTemplateCheckbox>
        <div class="d-flex align-items-center ps-4 ms-3">
          <label class="checkbox-inline-medium me-2">
            <input type="checkbox"
              [(ngModel)]="location.checked"
              (change)="onCheckboxSelectionChange(location, location.checked)"
              [id]="'checkbox-level-'+location.level+'-'+location.organizationUnitId">
          </label>
          <span class="text-block-dark"
            [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">{{ location.locationName
            }}</span>
          <a href="javascript:void(0)"
            (click)="establishmentInfo(location)"><i class="fa fa-info-circle"
              (click)="establishmentInfo(location)"
              style="color: #2477bf;margin-left: 8px;font-size: 18px !important;"
              *ngIf="location?.hasEstablishment && oshaHol==='osha'"
              [id]="'icon-info-circle-level-'+location.level+'-'+location.organizationUnitId"></i>
          </a>
        </div>
      </ng-template>
    </div>
  </div>

  <ng-template #recursiveListCheckbox
    let-childLocations>
    <div *ngFor="let childLocation of childLocations"
      class="location-item fs-14 my-2">
      <ng-container
        *ngIf="childLocation.childLocations && childLocation.childLocations.length; else leafNodeLocationTemplateCheckbox">
        <div class="d-flex align-items-center location-header my-2">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="childLocation.expanded = !childLocation.expanded"
            [id]="'button-caret-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
            <i class="fa"
              [ngClass]="childLocation.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-'+childLocation.level+'-'+childLocation.organizationUnitId"></i>
          </button>
          <label class="checkbox-inline-medium me-2">
            <input type="checkbox"
              [(ngModel)]="childLocation.checked"
              (change)="onCheckboxSelectionChange(childLocation, childLocation.checked)"
              [id]="'checkbox-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
          </label>
          <span class="text-block-dark"
            [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">{{
            childLocation.locationName }}</span>
          <a href="javascript:void(0)"
            (click)="establishmentInfo(childLocation)"> <i class="fa fa-info-circle"
              style="color: #2477bf;margin-left: 8px;font-size: 18px !important;"
              *ngIf="childLocation?.hasEstablishment && oshaHol==='osha'"
              [id]="'icon-info-circle-level-'+childLocation.level+'-'+childLocation.organizationUnitId"></i>
          </a>
        </div>
        <div *ngIf="childLocation.expanded"
          class="location-children my-2">
          <ng-container
            *ngTemplateOutlet="recursiveListCheckbox; context: { $implicit: childLocation.childLocations }"></ng-container>
        </div>
      </ng-container>
      <ng-template #leafNodeLocationTemplateCheckbox>
        <div class="d-flex align-items-center ps-4 ms-3">
          <label class="checkbox-inline-medium me-2">
            <input type="checkbox"
              [(ngModel)]="childLocation.checked"
              (change)="onCheckboxSelectionChange(childLocation, childLocation.checked)"
              [id]="'checkbox-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
          </label>
          <span class="text-block-dark"
            [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">{{
            childLocation.locationName }}</span>
          <a href="javascript:void(0)"
            (click)="establishmentInfo(childLocation)"><i class="fa fa-info-circle"
              style="color: #2477bf;margin-left: 8px;font-size: 18px !important;"
              *ngIf="childLocation.hasEstablishment && oshaHol==='osha'"
              [id]="'icon-info-circle-level-'+childLocation.level+'-'+childLocation.organizationUnitId"></i>
          </a>
        </div>
      </ng-template>
    </div>
  </ng-template>
</ng-container>

<!-- LEVEL CHECKBOX -->
<ng-container *ngIf="addFormType === 'levelCheckboxType'">
  <div *ngFor="let location of hierarchyOfLocationsData"
    class="location-item fs-14 my-2">
    <div>
      <ng-container *ngIf="location.childLocations && location.childLocations.length > 0; else noChildrenRoot">
        <div class="d-flex align-items-center location-header my-2">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="location.expanded = !location.expanded"
            [id]="'button-caret-level-'+location.level+'-'+location.organizationUnitId">
            <i class="fa"
              [ngClass]="location.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-'+location.level+'-'+location.organizationUnitId"></i>
          </button>
          <label *ngIf="location.level !== 1"
            class="checkbox-inline-medium me-2"
            [ngClass]="location.level !== selectedLevel ? 'disabled-checkbox-style' : ''">
            <input type="checkbox"
              [(ngModel)]="location.checked"
              (change)="onLevelCheckboxSelectionChange(location, location.checked)"
              [id]="'checkbox-level-'+location.level+'-'+location.organizationUnitId"
              [disabled]="location.level !== selectedLevel">
          </label>
          <span class="text-block-dark"
            [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">
            {{ getLocationNameOnly(location) }}
          </span>
        </div>
        <div *ngIf="location.expanded"
          class="location-children my-2">
          <ng-container
            *ngTemplateOutlet="recursiveListCheckboxStyledDisabled; context: { $implicit: location.childLocations }"></ng-container>
        </div>
      </ng-container>
      <ng-template #noChildrenRoot>
        <ng-container
          *ngTemplateOutlet="leafNodeLocationTemplateStyledDisabled; context: { $implicit: location }"></ng-container>
      </ng-template>
    </div>
  </div>

  <ng-template #recursiveListCheckboxStyledDisabled
    let-childLocations>
    <div *ngFor="let childLocation of childLocations"
      class="location-item fs-14 my-2">
      <ng-container
        *ngIf="childLocation.childLocations && childLocation.childLocations.length > 0; else noChildrenChild">
        <div class="d-flex align-items-center location-header my-2">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="childLocation.expanded = !childLocation.expanded"
            [id]="'button-caret-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
            <i class="fa"
              [ngClass]="childLocation.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-'+childLocation.level+'-'+childLocation.organizationUnitId"></i>
          </button>
          <label *ngIf="childLocation.level !== 1"
            class="checkbox-inline-medium me-2"
            [ngClass]="childLocation.level !== selectedLevel ? 'disabled-checkbox-style' : ''">
            <input type="checkbox"
              [(ngModel)]="childLocation.checked"
              (change)="onLevelCheckboxSelectionChange(childLocation, childLocation.checked)"
              [id]="'checkbox-level-'+childLocation.level+'-'+childLocation.organizationUnitId"
              [disabled]="childLocation.level !== selectedLevel">
          </label>
          <span class="text-block-dark"
            [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
            {{ getLocationNameOnly(childLocation) }}
          </span>
        </div>
        <div *ngIf="childLocation.expanded"
          class="location-children my-2">
          <ng-container
            *ngTemplateOutlet="recursiveListCheckboxStyledDisabled; context: { $implicit: childLocation.childLocations }"></ng-container>
        </div>
      </ng-container>
      <ng-template #noChildrenChild>
        <ng-container
          *ngTemplateOutlet="leafNodeLocationTemplateStyledDisabled; context: { $implicit: childLocation }"></ng-container>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #leafNodeLocationTemplateStyledDisabled
    let-childLocation>
    <div class="d-flex align-items-center ps-4 ms-3">
      <label *ngIf="childLocation.level !== 1"
        class="checkbox-inline-medium me-2"
        [ngClass]="childLocation.level !== selectedLevel ? 'disabled-checkbox-style' : ''">
        <input type="checkbox"
          [(ngModel)]="childLocation.checked"
          (change)="onLevelCheckboxSelectionChange(childLocation, childLocation.checked)"
          [id]="'checkbox-level-'+childLocation.level+'-'+childLocation.organizationUnitId"
          [disabled]="childLocation.level !== selectedLevel">
      </label>
      <span class="text-block-dark"
        [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
        {{ getLocationNameOnly(childLocation) }}
      </span>
    </div>
  </ng-template>
</ng-container>

<!--AddEditType-->
<ng-container *ngIf="addFormType === 'addEditType'">
  <div *ngFor="let location of hierarchyOfLocationsData"
    class="location-item fs-14">
    <div>

      <ng-container *ngIf="(!location.alternateOrganizationUnitId && !location.locationCode)
                && (location.childLocations && location.childLocations.length);
               else leafNodeLocationTemplate">

        <div class="location-header">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="toggleNode(location)"
            [id]="'button-caret-level-'+location.level+'-'+location.organizationUnitId">
            <i class="fa"
              [ngClass]="location.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-'+location.level+'-'+location.organizationUnitId"></i>
          </button>

          <span [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">
            {{ location.locationName }}
          </span>


          <i *ngIf="hasBurst"
            class="fa ms-2 btn-link"
            [ngClass]="location.hasAddress ? 'fa-pencil-square-o' : 'fa-pencil'"
            (click)="onEditLocation(location)"
            [title]="location.hasAddress ? 'Modify' : 'Add'">
          </i>
        </div>

        <div *ngIf="location.expanded"
          class="location-children">
          <ng-container *ngTemplateOutlet="recursiveListDisplayOnly; context: { $implicit: location.childLocations }">
          </ng-container>
        </div>
      </ng-container>


      <ng-template #leafNodeLocationTemplate>
        <div>
          <span class="ms-4 ps-3"
            [id]="'location-name-level-'+location.level+'-'+location.organizationUnitId">
            {{ location.locationName }}
          </span>

          <i *ngIf="hasBurst"
            class="fa ms-2 btn-link"
            [ngClass]="location.hasAddress ? 'fa-pencil-square-o' : 'fa-pencil'"
            (click)="onEditLocation(location)"
            [title]="location.hasAddress ? 'Modify' : 'Add'">
          </i>
        </div>
      </ng-template>
    </div>
  </div>

  <ng-template #recursiveListDisplayOnly
    let-childLocations>
    <div *ngFor="let childLocation of childLocations"
      class="location-item fs-14">
      <ng-container *ngIf="(!childLocation.alternateOrganizationUnitId && !childLocation.locationCode)
                && (childLocation.childLocations && childLocation.childLocations.length);
               else leafNodeLocationTemplateChild">

        <div class="location-header">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn btn-link p-0"
            (click)="toggleNode(childLocation)"
            [id]="'button-caret-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
            <i class="fa"
              [ngClass]="childLocation.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
              [id]="'icon-caret-level-'+childLocation.level+'-'+childLocation.organizationUnitId"></i>
          </button>

          <span [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
            {{ childLocation.locationName }}
          </span>


          <i *ngIf="hasBurst"
            class="fa ms-2 btn-link"
            [ngClass]="childLocation.hasAddress ? 'fa-pencil-square-o' : 'fa-pencil'"
            (click)="onEditLocation(childLocation)"
            [title]="childLocation.hasAddress ? 'Modify' : 'Add'">
          </i>
        </div>

        <div *ngIf="childLocation.expanded"
          class="location-children">
          <ng-container
            *ngTemplateOutlet="recursiveListDisplayOnly; context: { $implicit: childLocation.childLocations }">
          </ng-container>
        </div>
      </ng-container>

      <ng-template #leafNodeLocationTemplateChild>
        <div>
          <span class="ms-4 ps-3"
            [id]="'location-name-level-'+childLocation.level+'-'+childLocation.organizationUnitId">
            {{ childLocation.locationName }}
          </span>

          <i *ngIf="hasBurst"
            class="fa ms-2 btn-link"
            [ngClass]="childLocation.hasAddress ? 'fa-pencil-square-o' : 'fa-pencil'"
            (click)="onEditLocation(childLocation)"
            [title]="childLocation.hasAddress ? 'Modify' : 'Add'">
          </i>
        </div>
      </ng-template>
    </div>
  </ng-template>
</ng-container>

<app-draggable-card [widgetName]="'AssociatedEstablishment'"
  *ngIf="showModal"
  class="timeout-modal"
  [widgetDragDisabled]="false">
  <div left-title>
    <h4 class="mb-0 d-flex justify-content-between">Associated Establishment <span class="fa fa-close"
        style="margin-left: 50px;"
        role="button"
        (click)="close()"></span>
    </h4>
  </div>

  <div card-content-container>

    <div class="row">
      <div class="col-md-3"
        style="font-size: 14px !important; font-weight: bold;">Name:</div>
      <div class="col-md-9">
        <p style="font-size: 14px !important;">{{ selectedIcon?.name }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3"
        style="font-size: 14px !important; font-weight: bold;">Address:</div>
      <div class="col-md-9">
        <p style="font-size: 14px !important;">{{ selectedIcon?.address }}</p>
      </div>
    </div>

  </div>
</app-draggable-card>